exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preferred-location[data-v-40b3ed2e]{border:0;border-radius:3px;background-color:var(--light);color:var(--dark);font-size:14px;padding:.25rem .5rem;line-height:1;margin-bottom:1rem;transition:.2s ease-out}.preferred-location.active[data-v-40b3ed2e]{background-color:var(--themeColor-hsl);color:var(--themeCompliant-hsl)}.preferred-location>span[data-v-40b3ed2e]{display:flex;align-items:center}.preferred-location svg[data-v-40b3ed2e]{margin-right:.5em;font-size:12px}", ""]);

// exports
